import { Spinner } from '@change/ds-core-ui';

import { withPrefetchedData } from '#src/shared/prefetch';

import type { ContributionsPagePrefetchedDataProps } from '#src/app/pages/accountSettings/contributions/main/pageContext';
import {
	ContributionsPageContextProvider,
	prefetchPageContext,
} from '#src/app/pages/accountSettings/contributions/main/pageContext';

import { Layout } from '../layout';

import { ContributionsErrorHandler } from './ErrorHandler';

export const Contributions = withPrefetchedData(
	function Contributions({ prefetchedData }: ContributionsPagePrefetchedDataProps) {
		return (
			<ContributionsPageContextProvider
				prefetchedData={prefetchedData}
				errorHandler={ContributionsErrorHandler}
				loadingFallback={<Spinner className="mx-auto my-64" />}
			>
				<Layout />
			</ContributionsPageContextProvider>
		);
	},
	{
		prefetchName: __MODULE_HASH__,

		prefetchData: async (context) => prefetchPageContext(context),
	},
);
